export const STORAGE_KEYS = {
  TOKEN: 'token',
  LOCALE: 'RaStore.locale',
} as const;
